import { MonitoringEndpointService } from "@/views/monitoring/shared/endpoint_services/monitoring-endpoint-service"

export class MonitoringService {
    constructor () {
        this.monitoringEndpointService = new MonitoringEndpointService()
    }

    async getLastRecordOfMonitoring (pointIdAndTimeZone) {
        return this.monitoringEndpointService.getLastRecordOfMonitoring(pointIdAndTimeZone)
    }

    async getOfflinePoints (pointIds) {
        return this.monitoringEndpointService.getOfflinePoints(pointIds)
    }

    async getRecordForDashboard (pointIds) {
        return this.monitoringEndpointService.getRecordForDashboard(pointIds)
    }
}
